import React, { useEffect, useState } from "react";
import "../Accountsignup/Accountsignup.scss";
import DropdownInputs from "../DropdownInputs/DropdownInputs";
import { GetAllAccessLevel, GetAllDepartment } from "../../utils/apiCalls";
import { defaultDropdownConfig } from "../../services/GlobalFuction";
import { useNavigate } from "react-router-dom";
import Button from "../Button";

const initialValue = {
  accessLevelId: "",
  departmentId: "",
};

const CreateAccount = ({ registerData, setRegisterData, onNext, onBack }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState(initialValue);
  const [departmentList, setDepartmentList] = useState([]);
  const [accessLevelList, setAccessLevelList] = useState([]);

  const handleNav = () => {
    navigate("/");
  };

  const getAllDepartmentList = () => {
    GetAllDepartment((res) => {
      const { data } = res;
      const departmentList = data?.map((item) => ({
        label: item.departmentName,
        value: item.departmentId,
      })) || [];
      setDepartmentList(departmentList);
    }, defaultDropdownConfig);
  };

  const getAllAccessLevelList = () => {
    GetAllAccessLevel((res) => {
      const { data } = res;
      const accessLevelList = data?.map((item) => ({
        label: item.accessLevelName,
        value: item.accessLevelId,
      })) || [];
      setAccessLevelList(accessLevelList);
    }, defaultDropdownConfig);
  };  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegisterData({
      ...registerData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validateFields = () => {
    let errObj = { ...initialValue };
    if (!registerData.departmentId) {
      errObj.departmentId = "Department is required";
    } else {
      errObj.departmentId = "";
    }
    if (!registerData.accessLevelId) {
      errObj.accessLevelId = "Access Level is required";
    } else {
      errObj.accessLevelId = "";
    }
    setErrors(errObj);
    const data = Object.values(errObj).every((x) => x === "" || x === null);
    return data;
  };

  const handleCheckError = () => {
    if (validateFields()) onNext();
  };

  useEffect(() => {
    getAllDepartmentList();
    getAllAccessLevelList();
  }, []);

  return (
    <div className="account">
      <div className="account_box">
        <div className="account_box_header">
          <div className="account_box_header_heading">
            <h1>Create Account</h1>
          </div>
          <div className="account_box_header_text" onClick={handleNav}>
            <p>
              Already have an account? <span>Login</span>
            </p>
          </div>
          <div className="account_box_header_content">
            <div className="account_box_header_content_inputs">
              <DropdownInputs
                title="Department"
                name="departmentId"
                options={departmentList}
                placeholder={"Select your department"}
                value={registerData?.departmentId}
                onChange={handleChange}
                error={errors?.departmentId}
              />
            </div>
            <div className="account_box_header_content_inputs">
              <DropdownInputs
                title="Access level requested"
                name="accessLevelId"
                options={accessLevelList}
                placeholder={"Select your access level requested "}
                value={registerData?.accessLevelId}
                onChange={handleChange}
                error={errors?.accessLevelId}
              />
            </div>
            <div className="account_box_header_content_line"></div>
          </div>
        </div>
      </div>
      <div className="buttons">
        <Button
          disabled={!onBack}
          onClick={onBack}
        
        >
          &lt; Back
        </Button>
        <Button
          onClick={handleCheckError}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default CreateAccount;
